<template>
  <BaseModal 
    v-model="modal.isOpen" 
    :title="modal.title"
    :icon="modal.icon"
    :iconType="modal.iconType"
    maxWidth="max-w-md"
    @close="modal.cancel"
  >
    <div class="text-center py-2">
      <p class="text-gray-600 dark:text-gray-400" v-html="modal.message"></p>
    </div>
    <template #footer>
      <div class="flex gap-3">
        <button v-if="modal.type !== 'info'" @click="modal.cancel" class="flex-1 btn-secondary">
          {{ modal.cancelText }}
        </button>
        <button @click="modal.accept" :class="['flex-1', confirmClass]">
          {{ modal.confirmText }}
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { useModalStore } from '@/store/modal';
import BaseModal from './BaseModal.vue';

export default {
  name: 'GlobalModal',
  components: { BaseModal },
  setup() {
    const modal = useModalStore();
    return { modal };
  },
  computed: {
    confirmClass() {
      switch (this.modal.type) {
        case 'danger': return 'btn-danger';
        case 'success': return 'btn-success';
        case 'warning': return 'btn-warning';
        default: return 'btn-primary';
      }
    }
  }
};
</script>
